window.onload = () => {
  if (window.location.pathname === "/") {
    document.querySelectorAll("a").forEach(a => {
      if (a.href === "https://www.youtube.com/@OscarIchazoOnline") {
        a.target = "_blank";
      }
  });
  }
};